import { render, staticRenderFns } from "./QuestionBankArchives.vue?vue&type=template&id=e9b9b416&scoped=true"
import script from "./QuestionBankArchives.vue?vue&type=script&lang=js"
export * from "./QuestionBankArchives.vue?vue&type=script&lang=js"
import style0 from "./QuestionBankArchives.vue?vue&type=style&index=0&id=e9b9b416&prod&lang=css"
import style1 from "./QuestionBankArchives.vue?vue&type=style&index=1&id=e9b9b416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b9b416",
  null
  
)

export default component.exports